module.exports = __webpack_public_path__ + "static/img/icon_s.7baae623.png";